import React from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Icon, { DeleteOutlined, ExclamationCircleOutlined, FileOutlined } from '@ant-design/icons';
import { RICH_TEMPLATE_BUTTON_TYPE, TEMPLATE_HEADER_TYPE } from '../../../../../../../../constants';
import { ReactComponent as Plus } from '../../../../../../../../assets/icons/plus/quickRepliesPlus.svg';
import { ReactComponent as EditIcon } from '../../../../../../../../assets/icons/pencil/edit.svg';
import MessagePreview from '../../MessagePreview';
import MessagePreviewModal from '../../MessagePreviewModal';
import CommonButton from '../../../../../../common/CommonButton';
import { getDirection } from '../../../../../../../../helpers';
import { WhatsApp } from '@whatsper/texterchat-common';
import { useStore } from '../../../../../../../../store/rootStore';
import { observer } from 'mobx-react';
import s from '../RichParams.module.scss';
const { Text } = Typography;
const PreviewWrapperSection = ({ templateMessage, hasAllSampleParamsAdded, hasAtLeastOneSampleParamAdded, hasSampleParamsSetup, sampleDataModalIsOpen, fillButton, blockMessagePreviewField, templateIsApproved, switchOpenSampleDataModal, onMouseEnter, onMouseLeave, blockField, }) => {
    const { t } = useTranslation();
    const { templateMessagesStore: { richTemplateHeaderType, richTemplateHeader, richTemplateHeaderUrl, richTemplateFooter, callToActionButtons, quickReplyButtons, hasDocumentSample, richTemplateDocumentFilename, clearRichTemplateHeaderFile, }, } = useStore();
    const hasFile = richTemplateHeaderType &&
        [TEMPLATE_HEADER_TYPE.IMAGE, TEMPLATE_HEADER_TYPE.DOCUMENT, TEMPLATE_HEADER_TYPE.VIDEO].includes(richTemplateHeaderType);
    const hasUrlParams = callToActionButtons === null || callToActionButtons === void 0 ? void 0 : callToActionButtons.some((button) => button.url && /{{.*?}}/.test(button.url));
    return (React.createElement("div", { className: s.previewWrapper },
        React.createElement(MessagePreview, { header: {
                type: richTemplateHeaderType,
                text: richTemplateHeader,
                file: richTemplateHeader,
                url: richTemplateHeaderUrl || undefined,
            }, body: {
                text: templateMessage,
            }, footer: {
                type: WhatsApp.TemplateComponentType.FOOTER,
                text: richTemplateFooter || '',
            }, buttons: Object.assign(Object.assign({}, (quickReplyButtons && {
                type: RICH_TEMPLATE_BUTTON_TYPE.QUICK_REPLY,
                buttons: quickReplyButtons,
            })), (callToActionButtons && {
                type: RICH_TEMPLATE_BUTTON_TYPE.CALL_TO_ACTION,
                buttons: callToActionButtons,
            })) }),
        React.createElement("div", { className: s.sampleDataControls },
            hasDocumentSample && (React.createElement("div", { className: s.documentSample },
                React.createElement(FileOutlined, null),
                React.createElement(Text, { className: s.documentSampleName, title: richTemplateDocumentFilename || t('file') }, richTemplateDocumentFilename || t('file')),
                !blockField() && (React.createElement("button", { type: "button", className: s.removeDocumentSample, "aria-label": t('delete'), title: t('delete'), onClick: clearRichTemplateHeaderFile },
                    React.createElement(DeleteOutlined, null))))),
            React.createElement(CommonButton, { disabled: blockMessagePreviewField() || (!hasSampleParamsSetup && !hasFile && !hasUrlParams), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, action: switchOpenSampleDataModal },
                React.createElement("div", { className: classnames(s.previewButtonContent, {
                        [s.rtl]: getDirection() === 'rtl',
                    }) },
                    React.createElement(Icon, { className: classnames({ [s.iconFill]: fillButton }), component: hasAtLeastOneSampleParamAdded ? EditIcon : Plus }),
                    React.createElement(Text, { className: classnames({ [s.previewTextFill]: fillButton }) },
                        React.createElement(Trans, { i18nKey: templateIsApproved()
                                ? 'viewSampleData'
                                : hasAtLeastOneSampleParamAdded
                                    ? 'editSampleData'
                                    : 'addSampleData' }))))),
        !hasAllSampleParamsAdded && !templateIsApproved() && (React.createElement("div", { className: s.sampleDataErrorContainer },
            React.createElement(ExclamationCircleOutlined, { className: s.errorCircle }),
            React.createElement(Trans, { i18nKey: "provideSampleData" }))),
        React.createElement(MessagePreviewModal, { setModalVisible: switchOpenSampleDataModal, visible: sampleDataModalIsOpen, disabled: blockField() })));
};
export default observer(PreviewWrapperSection);
